import styled from "styled-components";

type PhotoViewLookAndFeel = {
    width: number; 
    height: number;
}

const photo_view_main: PhotoViewLookAndFeel = {
    width: 100,
    height: 100,
}

export type PhotoViewVariants = 'photo_view_main'

export const photo_view_variants: Map<PhotoViewVariants, PhotoViewLookAndFeel> = new Map<PhotoViewVariants, PhotoViewLookAndFeel>([
    ['photo_view_main', photo_view_main],
  ]);

export const Image = styled.img<{
    lookAndFeel: PhotoViewLookAndFeel
}>`
    width: ${(args) => args.lookAndFeel.width}%; 
    height: ${(args) => args.lookAndFeel.height}%;
`